import {css} from '@sail/engine/deprecated';
import {linkrebrandm1} from './icons/link-rebrand-icon';
import {DefaultTheme, Theme} from './theme';

// from lib/consumer/link_app/frontend/src/theme/tokens/color.ts
// Refer link storybook for more base colors, https://link-ui-storybook.stripe.me/?path=/docs/revamp-system-colors--docs
export const linkColors = {
  neutral: '#FFFFFF',
  neutral100: '#F5F5F5',
  neutral400: '#8D95A1',
  neutral500: '#707070',
  neutral800: '#1d3944',
  neutralBorder: '#0000001F',
  neutral900: '#171717',
  brand: '#00D66F',
  brand50: '#E6FFED',
  brand75: '#B3FECF',
  brand100: '#5EEE97',
  brand200: '#00D66F',
  brand300: '#00C767',
  brand400: '#00A355',
  brand500: '#008545',
  brand600: '#006635',
  brand700: '#034F28',
  brand800: '#023B1E',
  brand900: '#011E0F',
  brand1000: '#5f656eff',
  articleHeading: '#596171',
};

export const LinkTheme: Theme = {
  ...DefaultTheme,
  brandColor: linkColors.brand200,
  onBrandTextColor: linkColors.brand900,
  ctaColor: linkColors.brand200,
  ctaHoverColor: linkColors.brand100,
  onCtaTextColor: linkColors.brand900,
  textColor: linkColors.neutral800,
  linkColor: linkColors.brand500,
  avatarGradientStart: linkColors.brand200,
  avatarGradientEnd: linkColors.brand200,
  focusVisibleOutline: css.value(`2px solid ${linkColors.brand200}`),
  icon: linkrebrandm1,
  messageKey: 'link',
  artcileHeadingsColor: linkColors.articleHeading,
  articleLinkColor: linkColors.neutral900,
  primaryActionColor: linkColors.neutral900,
  pressedShadow: linkColors.brand1000,
  buttonBackgroundImage: `linear-gradient(white, white), linear-gradient(${linkColors.neutralBorder}, ${linkColors.neutralBorder})`,
  buttonBorderWidth: '1px',
  buttonHoverColor: linkColors.brand600,
  messageBubbleBackground: linkColors.brand600,
  assistantIconColor0: linkColors.brand600,
  assistantIconColor1: linkColors.brand200,
  assistantHeaderTitle: 'Link Support',
  audience: 'link',
  formBorderColor: linkColors.neutralBorder,
};
